<script setup lang="ts">
import { z } from 'zod'

const auth = useAuthStore()
const modals = useModalsStore()

const schema = toTypedSchema(
  z.object({
    email: z.string().email(),
  }),
)

const { errors, defineField, handleSubmit, isSubmitting } = useForm({
  validationSchema: schema,
})

const [email, emailAttrs] = defineField('email')

const onSubmit = handleSubmit(async (values) => {
  try {
    await auth.forgotPassword(values)

    modals.closeForgotPasswordModal()
  } catch (error) {
    // console.error(error)
  }
})
</script>

<template>
  <form @submit="onSubmit">
    <AppTextField
      v-model="email"
      v-bind="emailAttrs"
      :error="!!errors.email"
      class="mb-3 md:mb-4"
      type="email"
      :placeholder="$t('string.Email-address')"
      full-width
    />

    <AppButton type="submit" full-width :loading="isSubmitting">
      {{ $t('string.Submit') }}
    </AppButton>
  </form>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';
</style>
